function getRandomString() {
  return Math.random().toString(36).slice(2);
}
function configureContextSwitchHooks(opts) {
  const { gcinstant, replicantClientPromise } = opts;
  let replicant;
  void replicantClientPromise.then((replicantClient) => {
    replicant = replicantClient;
  });
  let latestContextSwitchEventId = getRandomString();
  gcinstant.beforeContextSwitch(() => {
    if (!replicant) {
      return;
    }
    gcinstant.setSessionData({
      ...replicant.getChatbotSessionData(),
      // Avoid invoking Replicant's onGameEnd handler on each context switch; see https://playco.atlassian.net/browse/CORE-1073:
      eventId: latestContextSwitchEventId,
      eventType: "CONTEXT_SWITCH"
    });
  });
  gcinstant.afterContextSwitch(() => {
    var _a;
    if (!replicant) {
      return;
    }
    gcinstant.setSessionData(replicant.getChatbotSessionData());
    if (!((_a = replicant.extras) == null ? void 0 : _a.afterContextSwitch)) {
      return;
    }
    replicant.extras.afterContextSwitch({
      contextSwitchEventId: latestContextSwitchEventId
    }).catch(
      (error) => console.error(
        "Replicant after context switch hook request failed:",
        error
      )
    );
    latestContextSwitchEventId = getRandomString();
  });
}
export {
  configureContextSwitchHooks
};
